import { render, staticRenderFns } from "./FollowUs.vue?vue&type=template&id=056936e5&"
import script from "./FollowUs.vue?vue&type=script&lang=js&"
export * from "./FollowUs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports